import { DotsDropdown, IDotsDropdownProps } from "dots-ui/dotsDropDown";
import { useMemo } from "react";

export function AvisDropdown<T, P = object>(
  props: Readonly<IDotsDropdownProps<T, P>>,
) {
  const { className, style, ...restProps } = props;
  const tooltipValue = useMemo(() => {
    const fieldValue = props.bagField
      ? (props.bag?.values as any)[props?.bagField]
      : props.value;

    if (!props.options) return;
    if (!fieldValue || props.options.length === 0) return undefined;

    const foundTiems = props.options.filter(
      (item) => (item as any)[props.optionValue] == fieldValue,
    );

    const firstItem = (foundTiems as any)?.[0];

    if (!firstItem) return undefined;

    return firstItem[props.optionLabel];
  }, [props]);

  return (
    <div title={tooltipValue} className={className} style={style}>
      <DotsDropdown<T, P> spacing="small" {...restProps} />
    </div>
  );
}
